import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import jornayaModule from '../jornaya';
import uiMask from 'angular-ui-mask'

import { JanglService } from './JanglService.js';
import { MetaService } from './MetaService.js'
import { PassthroughService } from './PassthroughService.js'
import { ContactService } from './ContactService.js';
import { DateService } from './DateService.js';
import { contactFieldsComponent } from './contact-fields/component.js';
import { extraFieldsComponent } from './extra-fields/component.js';
import { EdmundsService } from './EdmundsService.js';
import { AutoDataService } from './AutoDataService.js';
import { ExtraDataService } from "./ExtraDataService";
import { ExtraLabelService } from "./ExtraLabelService";
import { janglInputComponent } from './jangl-input/component.js';
import { janglSelectComponent } from './jangl-select/component.js';
import { janglDateComponent } from './jangl-date/component.js';
import { janglCheckboxComponent } from './jangl-checkbox/component.js';
import { janglTextareaComponent } from './jangl-textarea/component.js';
import { janglPageDoneComponent } from './jangl-page-done/component.js';
import { janglErrorsComponent } from './jangl-errors/component.js';


var module = angular.module('janglCaptureForms.jangl', [ngSanitize, uiMask, jornayaModule]);
module.service('janglService', JanglService);
module.service('janglMetaService', MetaService);
module.service('janglPassthroughService', PassthroughService);
module.service('janglContactService', ContactService );
module.service('janglExtraDataService', ExtraDataService );
module.service('janglExtraLabelService', ExtraLabelService );
module.service('janglDateService', DateService );
module.service('janglAutoDataService', AutoDataService );
module.service('janglEdmundsService', EdmundsService );
module.component('contactFields', contactFieldsComponent);
module.component('extraFields', extraFieldsComponent);
module.component('janglInput', janglInputComponent);
module.component('janglSelect', janglSelectComponent);
module.component('janglDate', janglDateComponent);
module.component('janglCheckbox', janglCheckboxComponent);
module.component('janglTextarea', janglTextareaComponent);
module.component('janglPageDone', janglPageDoneComponent);
module.component('janglErrors', janglErrorsComponent);
export default module.name;



// WEBPACK FOOTER //
// ./app/jangl/index.js